import { InvoiceDiscountType } from '../enums/invoiceDiscountType'

export const isPercentageDiscountType = (discountType: InvoiceDiscountType): boolean =>
  discountType === InvoiceDiscountType.Percentage
